import React, { Component } from 'react';

class TeamMembersTable extends Component {
    render() {
        return (
            <table className="table table-hover">
                <thead>
                    <tr>
                        <th>#</th>
                        <th>First Name</th>
                        <th>Last Name</th>
                        <th>Email</th>
                        <th>Mobile</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>1</td>
                        <td>John</td>
                        <td>Doe</td>
                        <td>john@doe.com</td>
                        <td>069555333</td>
                    </tr>
                    <tr>
                        <td>2</td>
                        <td>John</td>
                        <td>Doe</td>
                        <td>john@doe.com</td>
                        <td>069555333</td>
                    </tr>
                    <tr>
                        <td>3</td>
                        <td>John</td>
                        <td>Doe</td>
                        <td>john@doe.com</td>
                        <td>069555333</td>
                    </tr>
                </tbody>
            </table>
        );
    }
}

export default TeamMembersTable;
